import { Suspense } from "react";
import { signOut } from "../../app/auth.js";
import { Link } from "../../app/router.js";
import { t } from "../../shared/i18n.js";
import { PageHead } from "../../shared/common.js";
import { useApp } from "../../shared/context.js";
import { Icon } from "../../shared/Icon.js";
import { ContentSettings } from "./content.js";

/** Les initiales du compte, dans l'avatar des Réglages. */
function useInitials() {
  const { session } = useApp();
  const name = session.name ?? session.email?.split("@")[0] ?? "";
  return (name.replace(/[^\p{L}\p{N}]/gu, "") || "?").slice(0, 2).toUpperCase();
}

// « Ton contenu » tire le modèle du Studio : chargé seulement quand on ouvre les Réglages.

/**
 * Réglages (audit §4.10, ex-« Moi ») : le compte, « Ton contenu » (ce que tu fais, ton compte public, ce que l'IA
 * a compris — les idées en partent), puis l'app : la Bibliothèque, la confidentialité, la déconnexion.
 */
export function Me() {
  const { session } = useApp();
  return (
    <main className="page narrow settings-page" data-testid="settings">
      <PageHead title={t("nav.settings")} />
      <div className="row settings-who">
        <span className="avatar">{useInitials()}</span>
        <span className="grow ellipsis">{session.email ?? (session.dev ? "Dev" : session.name)}</span>
      </div>
      <Suspense fallback={null}>
        <ContentSettings />
      </Suspense>
      <section className="settings-group" aria-labelledby="settings-app">
        <h2 id="settings-app" className="settings-head">
          {t("settings.app")}
        </h2>
        <div className="list settings-list">
          <Link className="list-row settings-row" to="/moi/memoire" data-testid="settings-memory">
            <Icon name="spark" />
            <span className="grow">{t("memory.row")}</span>
            <Icon name="right" size="sm" />
          </Link>
          <Link className="list-row settings-row" to="/bibliotheque" data-testid="settings-library">
            <Icon name="library" />
            <span className="grow">{t("nav.library")}</span>
            <Icon name="right" size="sm" />
          </Link>
          <Link className="list-row settings-row" to="/inspiration" data-testid="settings-styles">
            <Icon name="inspiration" />
            <span className="grow">{t("settings.styles")}</span>
            <Icon name="right" size="sm" />
          </Link>
          <Link className="list-row settings-row" to="/confidentialite">
            <Icon name="info" />
            <span className="grow">{t("privacy.link")}</span>
            <Icon name="right" size="sm" />
          </Link>
        </div>
      </section>
      <div className="list settings-list">
        <button className="list-row settings-row danger" onClick={() => void signOut()}>
          <Icon name="arrowRight" />
          <span className="grow">{t("common.signOut")}</span>
        </button>
      </div>
    </main>
  );
}
